import "@/App.css";
import { LanguageProvider } from "./i18n/LanguageContext";
import { Navbar } from "./sections/Navbar";
import { Hero } from "./sections/Hero";
import { About } from "./sections/About";
import { Services } from "./sections/Services";
import { Reviews } from "./sections/Reviews";
import { Gallery } from "./sections/Gallery";
import { Hours } from "./sections/Hours";
import { Contact } from "./sections/Contact";
import { Footer } from "./sections/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-[#050505] text-white" data-testid="app-root">
        <Navbar />
        <main>
          <Hero />
          <About />
          <Services />
          <Reviews />
          <Gallery />
          <Hours />
          <Contact />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
